module.exports = parcelRequire.resolve("eV24G");